import * as tslib_1 from "tslib";
import { CandidateAdditionalDetails } from "../../../models/candidateAdditionalDetails";
import { ScreeningExecutionResult } from "../../../models/screeningExecutionResult";
class FeedbackExecutionController {
    /*@ngInject*/
    constructor($rootScope, $scope, $timeout, $uibModal, $uibModalStack, companyService, feedbackExecutionService, userRoleService, jobMatchService, candidateService, meetingService, modalService, dateTimeUtilityService, alertsAndNotificationsService, sharedService, MESSAGECONSTANTS, outreachService, jobService, authService) {
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$uibModal = $uibModal;
        this.$uibModalStack = $uibModalStack;
        this.companyService = companyService;
        this.feedbackExecutionService = feedbackExecutionService;
        this.userRoleService = userRoleService;
        this.jobMatchService = jobMatchService;
        this.candidateService = candidateService;
        this.meetingService = meetingService;
        this.modalService = modalService;
        this.dateTimeUtilityService = dateTimeUtilityService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.sharedService = sharedService;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
        this.outreachService = outreachService;
        this.jobService = jobService;
        this.authService = authService;
    }
    $onChanges(changes) {
        // console.log(changes);
        let hasUsersListChanged = this._isNotInit(changes) && changes.usersToEditFeedback !== undefined && this._hasFeedbackUsersChanged(changes);
        if (hasUsersListChanged) {
            this.setFeedbackEnabledAttendeeId();
        }
        if (changes.activeOutreachFeedbackQuestionsList) {
            this.setOutreachQuestionsForFeedback(changes.activeOutreachFeedbackQuestionsList.currentValue);
        }
        if (changes.outreachData && !changes.outreachData.isFirstChange() && changes.outreachData.currentValue) {
            this.setOutreachFeedbackData(changes.outreachData.currentValue);
        }
    }
    _hasFeedbackUsersChanged(changes) {
        if (_.isEmpty(changes.usersToEditFeedback.previousValue)) {
            return true;
        }
        let previousAttendees = changes.usersToEditFeedback.previousValue.map(attendee => attendee.attendeeId).sort();
        let currentAttendees = changes.usersToEditFeedback.currentValue.map(attendee => attendee.attendeeId).sort();
        return !_.isEqual(previousAttendees, currentAttendees);
    }
    _isNotInit(changes) {
        return changes.externalMeetingCallId == undefined;
    }
    $onInit() {
        // initialize variables
        this.totalClQnsCount = 0;
        this.totalCount = 0;
        this.recruiterqns = null;
        this.companyQnsComplete;
        this.type;
        this.externalNotesAction = {};
        this.companyId = null;
        this.feedbackQuestionsCompanyId = null;
        this.loggedInUserId = null;
        this.showMeetingLink = false;
        this.isCorporateFlag = false;
        this.showInterested = true;
        this.savingFlag = false;
        this.completingFlag = false;
        this.saveComplete = false;
        this.displayQuestions = false;
        this.userList = [];
        this.savedRecruiterQns;
        this.userGetRecruiterQns;
        this.jobMatch;
        this.candidateJobMatch = {};
        this.displayRecruiterName = false;
        this.feedbackTypeLabel = '';
        this.noEditableMeetingsLabel = '';
        this.completeButtonLabel = '';
        this.userId = null;
        this.chosenUser = null;
        this.chosenMeeting = null;
        this.screeningFeedbackStartedData = null;
        this.previousEnableEditFor = null;
        // flags
        this.loadingJobMatchDetailsFlag = false;
        this.loadingFeedbackOptionsFlag = false;
        this.loadingFeedbackDetailsFlag = false;
        this.showAdditionalCandidateDetailsFlag = false;
        this.showMeetingsFlag = false;
        this.editableMeetingsExistFlag = false;
        this.clientOrBuExists = true;
        this.userHasAccessToFeedback = false;
        this.showAllCompanyQuestionComments = true;
        this.showAllClientQuestionComments = true;
        this.loadingUsers = true;
        this.showChosenUserDetails = true;
        this.isCompanyQuestionExists = false;
        // this.disableRequestToEditButton = false;
        this.getAllPreferredJobTypes();
        this.getSalaryDurationOptions();
        this.init(false);
        if (this.externalMeetingCallId) {
            this._setMeetingListeners();
        }
        this._checkAndSaveFeedbackIfMeetingEnd();
        // Formalize comments (Users only)
        this.formalizeItemsArray = this._getAllItemsArray();
    }
    init(refreshFlag) {
        if (this.loginRequired == undefined) {
            this.loginRequired = true;
        }
        if (this.parentScheduleId == undefined) {
            this.parentScheduleId = null;
        }
        if (this.childScheduleId == undefined) {
            this.childScheduleId = null;
        }
        if (this.externalCommentRequired == undefined) {
            this.externalCommentRequired = false;
        }
        if (this.usersToEditFeedback == undefined) {
            this.usersToEditFeedback = [];
        }
        if (this.feedbackReadOnly == undefined) {
            this.feedbackReadOnly = false;
        }
        if (this.context == 'conference' && this.externalMeetingCallId) {
            this.setFeedbackEnabledAttendeeId();
        }
        this.meetingsList = [];
        this.loggedInUserId = this.authService.getUserDetails().id;
        this.companyId = this.authService.getUserDetails().company.companyId;
        this.isCorporateFlag = (this.authService.getUserDetails().company.companyType === this.MESSAGECONSTANTS.COMPANY_TYPES.CORPORATE);
        this.feedbackExecutionResult = new ScreeningExecutionResult();
        this._setLabels();
        if (!_.isUndefined(refreshFlag) && refreshFlag) {
            this.loadingFeedbackOptionsFlag = true;
            this.loadingFeedbackDetailsFlag = true;
        }
        else {
            this.loadingJobMatchDetailsFlag = true;
        }
        this.isCandidateContactDetailsMissing = false;
        this.isCandidateContactAdditionalDetailsMissing = false;
        if (this.context === 'outreach') {
            this.getOutreachFeedbackQuestions();
        }
        else {
            this.getCandidateJobMatchCardInfo(refreshFlag, () => {
                this.loadingJobMatchDetailsFlag = false;
                if (this.feedbackType == 'Screening') {
                    this.loadingFeedbackOptionsFlag = true;
                    this.getUserList(() => {
                        this.loadingFeedbackOptionsFlag = false;
                        this.showChosenUserDetails = true;
                        if (this._isCorporateAccessingVendorCandidateFeedback()) {
                            this.chosenUser = this.userList[0];
                            this.feedbackEntityChanged();
                            this.showChosenUserDetails = false;
                        }
                        // if a user id was passed in to the directive
                        else if (!_.isUndefined(this.feedbackUserIdsList) && this.feedbackUserIdsList.length > 0) {
                            if (_.isUndefined(refreshFlag) || !refreshFlag) {
                                // if it is not refresh mode
                                if (!_.isUndefined(this.feedbackUserIdsList) && this.feedbackUserIdsList.length > 0) {
                                    // if feedbackUserIdsList is not undefined / not passed in
                                    this.feedbackUserIdsList = JSON.parse(this.feedbackUserIdsList);
                                }
                            }
                            let passedInUser = {};
                            angular.forEach(this.userList, (val, key) => {
                                angular.forEach(this.feedbackUserIdsList, (passedInUserId, key) => {
                                    if (val.id == passedInUserId) {
                                        passedInUser = val;
                                        this.userId = val.id;
                                    }
                                });
                            });
                            this.userList = [];
                            this.userList.push(passedInUser);
                            this.chosenUser = passedInUser;
                            this.feedbackEntityChanged();
                        }
                        else if (this.userList.length == 1) {
                            this.chosenUser = this.userList[0];
                            this.feedbackEntityChanged();
                        }
                        else {
                            // there exist multiple users and refresh flag is true
                            if (!_.isUndefined(refreshFlag) && refreshFlag) {
                                this.$timeout(() => {
                                    $('#chosenUser-' + this.chosenUser.id).prop("checked", true);
                                }, 500);
                                // reload the feedback data
                                this.feedbackEntityChanged();
                            }
                        }
                        this.checkRecruiterScreeningStatus();
                    }, () => {
                        this.loadingFeedbackOptionsFlag = false;
                    });
                }
                else if (this.feedbackType == 'Interview') {
                    this.showMeetingsFlag = false;
                    this.loadingFeedbackOptionsFlag = true;
                    let loggedInUserId = null;
                    if (!this.loginRequired) {
                        loggedInUserId = this.loggedInUserId;
                    }
                    this.jobMatchService.getInterviewers(this.jobMatchId, this.companyId, loggedInUserId, false, (data) => {
                        this._massageMeetingDetails(data, refreshFlag);
                    }, (error) => {
                        this.loadingFeedbackOptionsFlag = false;
                        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    });
                }
                else if (this.feedbackType == 'PhoneScreen') {
                    this.showMeetingsFlag = false;
                    this.loadingFeedbackOptionsFlag = true;
                    let loggedInUserId = null;
                    if (!this.loginRequired) {
                        loggedInUserId = this.loggedInUserId;
                    }
                    this.jobMatchService.getPhoneScreeners(this.jobMatchId, this.companyId, loggedInUserId, false, (data) => {
                        this._massageMeetingDetails(data, refreshFlag);
                    }, (error) => {
                        this.loadingFeedbackOptionsFlag = false;
                        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    });
                }
            });
        }
    }
    _onCommentChange() {
        try {
            this.formalizeItemsArray = this._getAllItemsArray();
        }
        catch (e) {
            this.formalizeItemsArray = [];
        }
    }
    _getAllItemsArray() {
        const out = [];
        if (!this.recruiterqns)
            return out;
        // 1) Company questions
        try {
            const coKey = this.feedbackQuestionsCompanyId;
            const companyQuestions = this.recruiterqns.companyQuestionsResults && this.recruiterqns.companyQuestionsResults[coKey] ? this.recruiterqns.companyQuestionsResults[coKey] : [];
            companyQuestions.forEach(q => {
                const text = (q.recruiterComment || q.recruiterNote || '').trim();
                if (text && String(text).trim().length > 0) {
                    const id = q.id != null ? String(q.id) : Math.random().toString(36).slice(2, 8);
                    out.push({ key: `company-${id}`, label: q.question || 'Company Comment', text: text, companyName: this.recruiterqns.companyName || null });
                }
            });
        }
        catch (e) { }
        // 2) Client questions
        try {
            const clientResults = this.recruiterqns.clientQuestionsResults || {};
            Object.keys(clientResults).forEach(clientKey => {
                const arr = clientResults[clientKey] || [];
                arr.forEach(q => {
                    const text = (q.recruiterComment || q.recruiterNote || '').trim();
                    if (text && String(text).trim().length > 0) {
                        const id = q.id != null ? String(q.id) : Math.random().toString(36).slice(2, 8);
                        out.push({ key: `client-${clientKey}-${id}`, label: q.question || 'Client Comment', text: text, companyName: this.recruiterqns.clientDetails ? this.recruiterqns.clientDetails[clientKey] : null });
                    }
                });
            });
        }
        catch (e) { }
        // 3) Job questions
        try {
            const jobResults = this.recruiterqns.jobQuestionsResults || {};
            Object.keys(jobResults).forEach(jobKey => {
                const arr = jobResults[jobKey] || [];
                arr.forEach(q => {
                    const text = (q.recruiterComment || q.recruiterNote || '').trim();
                    if (text && String(text).trim().length > 0) {
                        const id = q.id != null ? String(q.id) : Math.random().toString(36).slice(2, 8);
                        out.push({ key: `job-${jobKey}-${id}`, label: q.question || 'Job Comment', text: text, companyName: this.recruiterqns.companyName || null });
                    }
                });
            });
        }
        catch (e) { }
        return out;
    }
    handleBulkSave(updatedItems) {
        const items = (updatedItems && updatedItems.entity && updatedItems.entity.items) ? updatedItems.entity.items : updatedItems;
        if (!items || !Array.isArray(items))
            return;
        items.forEach(u => {
            const key = u.key || '';
            try {
                if (key.indexOf('company-') === 0) {
                    const id = key.substring('company-'.length);
                    Object.keys(this.recruiterqns.companyQuestionsResults || {}).forEach(k => {
                        const arr = this.recruiterqns.companyQuestionsResults[k];
                        if (Array.isArray(arr)) {
                            arr.forEach(q => { if (String(q.id) == String(id))
                                q.recruiterComment = u.text; });
                        }
                    });
                }
                else if (key.indexOf('client-') === 0) {
                    const parts = key.split('-');
                    const clientKey = parts[1];
                    const id = parts.slice(2).join('-');
                    const arr = (this.recruiterqns.clientQuestionsResults && this.recruiterqns.clientQuestionsResults[clientKey]) || [];
                    arr.forEach(q => { if (String(q.id) == String(id))
                        q.recruiterComment = u.text; });
                }
                else if (key.indexOf('job-') === 0) {
                    const parts = key.split('-');
                    const jobMatchId = parts[1];
                    const id = parts.slice(2).join('-');
                    const arr = (this.recruiterqns.jobQuestionsResults && this.recruiterqns.jobQuestionsResults[jobMatchId]) || [];
                    arr.forEach(q => { if (String(q.id) == String(id))
                        q.recruiterComment = u.text; });
                }
            }
            catch (e) {
                // ignore mapping errors
            }
        });
        // Persist changes by invoking the existing saveResults flow
        // this.saveResults('save');
        // Exit formalize mode
        this.formalizeMode = false;
        this.formalizeItems = null;
        this.selectedComments = {};
        this.selectedCommentsMap = {};
    }
    onToggleSelect(key, obj, prop, label) {
        if (!this.selectedComments)
            this.selectedComments = {};
        if (!this.selectedCommentsMap)
            this.selectedCommentsMap = {};
        if (this.selectedComments[key]) {
            this.selectedCommentsMap[key] = { obj: obj, prop: prop, label: label || key };
        }
        else {
            delete this.selectedCommentsMap[key];
        }
    }
    hasSelectedComments() {
        return this.selectedCommentsMap && Object.keys(this.selectedCommentsMap).length > 0;
    }
    _getSelectedItemsArray() {
        const out = [];
        if (!this.selectedCommentsMap)
            return out;
        Object.keys(this.selectedCommentsMap).forEach(k => {
            const m = this.selectedCommentsMap[k];
            let companyOrClient = null;
            // Try to infer client/company name from the selected item.
            // Keys for selections use patterns like:
            //  - 'company-<questionId>'
            //  - 'client-<clientKey>-<questionId>'
            //  - 'overall-<questionId>'
            // For client selections we can look up recruiterqns.clientDetails[clientKey].
            if (k && k.indexOf('client-') === 0) {
                const parts = k.split('-');
                const clientKey = parts.length >= 2 ? parts[1] : null;
                if (clientKey && this.recruiterqns && this.recruiterqns.clientDetails) {
                    companyOrClient = this.recruiterqns.clientDetails[clientKey] || null;
                }
            }
            // For company / overall, use top-level company name when available
            if (!companyOrClient && k && (k.indexOf('company-') === 0 || k.indexOf('overall-') === 0)) {
                companyOrClient = this.recruiterqns && this.recruiterqns.companyName ? this.recruiterqns.companyName : null;
            }
            // Fallback to any name available on the object itself
            if (!companyOrClient && m.obj) {
                companyOrClient = m.obj.companyName || m.obj.clientOrBUName || m.obj.clientName || m.obj.company || m.obj.client || m.obj.CompanyName || null;
            }
            const textVal = (m.obj && m.obj[m.prop]) ? m.obj[m.prop] : '';
            if (textVal && String(textVal).trim().length > 0) {
                out.push({ key: k, label: m.label, text: textVal, companyName: companyOrClient });
            }
        });
        return out;
    }
    _isCorporateAccessingVendorCandidateFeedback() {
        return this.companyService.isCorporateCompany() && !this._isUserOfSameCompany(this.userList[0].id);
    }
    setFeedbackEnabledAttendeeId() {
        this.loadingUsers = true;
        this.meetingService.getFeedbackEditEnabledAttendeeId(this.externalMeetingCallId, data => {
            this.enableEditForAttendeeId = data.attendeeId;
            this.previouslyEnabledEditForAttendeeId = data.attendeeId;
            this._setUserToEditFeedback();
        }, error => {
            //do nothing
        });
    }
    _setMeetingListeners() {
        this.cleanUpMeetingEventOne = this.$rootScope.$on("PARTICIPANT_FEEDBACK_EDIT_REQUEST", (event, message) => {
            this.openEditFeedbackApprovalModal(message);
        });
        this.cleanUpMeetingEventTwo = this.$rootScope.$on("PARTICIPANT_FEEDBACK_EDIT_REJECT", (event, message) => {
            // this.disableRequestToEditButton = false;
            bootbox.alert({
                closeButton: false,
                title: "<div class='alert alert-warning mb-0'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Edit Request Denied</strong></div>",
                message: 'Your request to edit the feedback has been denied. Please try again later.',
                className: "zIndex1060",
                buttons: {
                    ok: {
                        label: 'Ok',
                        className: 'btn-info'
                    }
                },
                callback: () => {
                    //do nothing
                }
            });
        });
        this.cleanUpMeetingEventThree = this.$rootScope.$on("REFRESH_FEEDBACK_TAB", (event, message) => {
            this.init(true);
        });
    }
    _setUserToEditFeedback() {
        this.loadingUsers = true;
        if (this.usersToEditFeedback && this.usersToEditFeedback.length > 0) {
            this.enabledEditForUser = this.usersToEditFeedback.find(user => user.attendeeId == this.enableEditForAttendeeId);
            if (this.enabledEditForUser !== undefined) {
                this.feedbackReadOnly = this.enabledEditForUser.displayName !== 'You';
                this.previousEnableEditFor = angular.copy(this.enabledEditForUser);
            }
        }
        this.$timeout(() => {
            this.loadingUsers = false;
        }, 2000);
    }
    _setLabels() {
        if (_.isNull(this.feedbackType) || _.isUndefined(this.feedbackType)) {
            this.feedbackType = 'Screening';
            this.feedbackTypeLabel = 'Screening Feedback for';
            this.getCandidateProfile(() => {
                this.showAdditionalCandidateDetailsFlag = true;
            });
        }
        else {
            if (this.feedbackType == 'Interview') {
                this.feedbackTypeLabel = 'Interview Feedback for';
                this.noEditableMeetingsLabel = "No 'Interviews' available for Feedback !";
            }
            else if (this.feedbackType == 'PhoneScreen') {
                this.feedbackTypeLabel = 'Phone Screen Feedback for';
                this.noEditableMeetingsLabel = "No 'Phone Screens' available for Feedback !";
            }
            else if (this.feedbackType == 'Outreach') {
                this.feedbackTypeLabel = 'Outreach Feedback for';
            }
            else {
                this.feedbackTypeLabel = 'Screening Feedback for';
                this.getCandidateProfile(() => {
                    this.showAdditionalCandidateDetailsFlag = true;
                });
            }
        }
    }
    _massageMeetingDetails(data, refreshFlag) {
        this._setMeetingsList(data);
        // if a user id was passed in to the directive
        if (!_.isUndefined(this.feedbackUserIdsList) && this.feedbackUserIdsList.length > 0) {
            if (_.isUndefined(refreshFlag) || !refreshFlag) {
                // if it is not refresh mode
                if (!_.isUndefined(this.feedbackUserIdsList) && this.feedbackUserIdsList.length > 0) {
                    // if feedbackUserIdsList is not undefined / not passed in
                    this.feedbackUserIdsList = JSON.parse(this.feedbackUserIdsList);
                }
            }
            let meetings = _.filter(this.meetingsList, (meeting) => {
                return meeting.meetingScheduleId == this.parentScheduleId;
            });
            this.meetingsList = angular.copy(meetings);
            this.chosenMeeting = this.meetingsList[0];
            this.loadingFeedbackOptionsFlag = false;
            this.feedbackEntityChanged();
        }
        else if (this.meetingsList.length == 1) {
            this.loadingFeedbackOptionsFlag = false;
            this.chosenMeeting = this.meetingsList[0];
            this.feedbackEntityChanged();
        }
        else {
            this.loadingFeedbackOptionsFlag = false;
        }
        this.showMeetingsFlag = true;
        // there exist multiple meetings and refresh flag is true
        if (this.meetingsList.length > 1 && !_.isUndefined(refreshFlag) && refreshFlag) {
            this.$timeout(() => {
                $('#chosenMeeting-' + this.chosenMeeting.id).prop("checked", true);
            }, 500);
            // reload the feedback data
            this.feedbackEntityChanged();
        }
    }
    getCandidateProfile(successCallback) {
        this.candidateService.getCandidateProfile(this.candidateId, false, (data) => {
            this.candidateAdditionalDetails = data.candidateAdditionalDetails;
            if (_.isNull(this.candidateAdditionalDetails)) {
                this.candidateAdditionalDetails = new CandidateAdditionalDetails();
            }
            this.candidateAdditionalDetails.candidateId = this.candidateId;
            this.savedCandidateAdditionalDetails = angular.copy(this.candidateAdditionalDetails);
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    checkRecruiterScreeningStatus() {
        this.screeningFeedbackStartedData = null;
        let userIdToCheckScreeningStatus = _.isNull(this.userId) ? this.loggedInUserId : this.userId;
        this.feedbackExecutionService.checkRecruiterScreeningStatus(this.jobMatchId, userIdToCheckScreeningStatus, this.companyId, (data) => {
            if (data.status == 'STARTED') {
                this.screeningFeedbackStartedData = data;
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    feedbackEntityChanged() {
        // reset question counts
        this.totalClQnsCount = 0;
        this.totalCount = 0;
        this.showMeetingLink = false;
        if (this.feedbackType == 'Screening') {
            this.userGetRecruiterQns = this.chosenUser.id;
            this._setUserAccessToFeedback(this.chosenUser.employer.id);
            if (this.candidateJobMatch.jobMatchCurrentState == 'Activated') {
                this.completeButtonLabel = 'Update';
            }
            else {
                this.completeButtonLabel = 'Complete';
            }
        }
        else {
            // as of now, choose the first user in the list of users on the meeting.
            this.userGetRecruiterQns = this.chosenMeeting.userList[0].userId;
            this._setUserAccessToFeedback(this.chosenMeeting.userList[0].companyId);
            // this.parentScheduleId = this.chosenMeeting.meetingScheduleId;
            if (this.chosenMeeting.status == 'COMPLETED') {
                this.completeButtonLabel = 'Update';
                this.showMeetingLink = false;
            }
            else {
                this.completeButtonLabel = 'Complete';
                if (this.chosenMeeting.meetingMode !== null && this.context !== 'conference') {
                    this.showMeetingLink = true;
                    let workflowStep = this.feedbackType == 'Interview' ? 'in' : 'ps';
                    this.chosenMeeting.meetingUrl = this.meetingService.getMeetingUrl(this.chosenMeeting.id, workflowStep, this.chosenMeeting.meetingMode);
                }
                else {
                    this.showMeetingLink = false;
                }
            }
        }
        this.getRecruiterQuestions();
    }
    _setUserAccessToFeedback(participantCompanyId) {
        if (!this.loginRequired) {
            this.userHasAccessToFeedback = true;
        }
        else {
            this.userHasAccessToFeedback = this.userRoleService.isLoggedInUserSuperUserOr4dot5Admin() || this._isUserOfSameCompany(participantCompanyId) || this.feedbackType !== 'Screening';
        }
    }
    _isUserOfSameCompany(participantCompanyId) {
        return this.candidateJobMatch.jobMatchCompanyId == null || participantCompanyId == this.candidateJobMatch.jobMatchCompanyId;
    }
    getCandidateJobMatchCardInfo(refreshFlag, successCallback) {
        if (!_.isUndefined(refreshFlag) && refreshFlag) {
            if (successCallback) {
                successCallback();
            }
        }
        else {
            let loggedInUserId;
            if (!this.loginRequired) {
                loggedInUserId = this.loggedInUserId;
            }
            this.jobMatchService.getCandidateJobMatchCard(this.jobMatchId, this.companyId, (data) => {
                data.name = data.firstName + ' ' + data.lastName;
                angular.merge(this.candidateJobMatch, data);
                this._checkIfContactDetailsMissing();
                if (successCallback) {
                    successCallback();
                }
            }, (error) => {
                if (this.$rootScope.isOnline) {
                    this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
            }, loggedInUserId);
        }
    }
    getUserList(successCallback, errorCallback) {
        this.feedbackExecutionService.getUserList(this.jobMatchId, this.companyId, (data) => {
            this.userList = angular.copy(data);
            this.displayRecruiterName = true;
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            if (errorCallback) {
                errorCallback();
            }
        });
    }
    _setMeetingsList(response) {
        this.meetingsList = [];
        let workflowStep = this.feedbackType == 'Interview' ? 'in' : 'ps';
        angular.forEach(response, (meetingDetails, key) => {
            let meeting = {};
            meeting.id = meetingDetails.meetingScheduleId;
            meeting.status = meetingDetails.status;
            meeting.meetingScheduleId = meetingDetails.meetingScheduleId;
            meeting.meetingMode = meetingDetails.meetingMode;
            meeting.meetingUrl = this.meetingService.getMeetingUrl(meeting.id, workflowStep, meeting.meetingMode);
            //let currentDateTime = new Date();
            let startDateTime = new Date(meetingDetails.meetingStartTime);
            let endDateTime = new Date(meetingDetails.meetingEndTime);
            switch (meeting.status) {
                case 'SCHEDULED':
                case 'ACTIVE':
                    meeting.statusClass = 'fa fa-calendar feedback-meeting-icon-scheduled';
                    meeting.statusLabel = 'Scheduled';
                    meeting.editableFlag = true;
                    this.editableMeetingsExistFlag = true;
                    break;
                case 'IN_PROGRESS':
                    meeting.statusClass = 'fa fa-hourglass-half feedback-meeting-icon-in-progress';
                    meeting.statusLabel = 'In Progress';
                    meeting.editableFlag = true;
                    this.editableMeetingsExistFlag = true;
                    break;
                case 'COMPLETED':
                    meeting.statusClass = 'fa fa-check feedback-meeting-icon-completed';
                    meeting.statusLabel = 'Completed';
                    meeting.editableFlag = true;
                    this.editableMeetingsExistFlag = true;
                    break;
                case 'OVERDUE':
                    meeting.statusClass = 'fas fa-clock feedback-meeting-icon-overdue';
                    meeting.statusLabel = 'Overdue';
                    meeting.editableFlag = true;
                    this.editableMeetingsExistFlag = true;
                    break;
                case 'CANCELLED':
                    meeting.statusClass = 'fa fa-ban feedback-meeting-icon-cancelled';
                    meeting.statusLabel = 'Canceled';
                    meeting.editableFlag = false;
                    break;
                default:
                    // set defaults
                    meeting.statusClass = 'fa fa-question feedback-meeting-icon-in-progress';
                    meeting.statusLabel = 'Status Unknown';
                    meeting.editableFlag = false;
            }
            switch (meeting.meetingMode) {
                case 'VIDEO':
                    meeting.meetingModeClass = 'fas fa-video';
                    break;
                case 'AUDIO':
                    meeting.meetingModeClass = 'fas fa-microphone';
                    break;
                case 'PHONE':
                    meeting.meetingModeClass = 'fas fa-phone';
                    break;
                case 'FACE_TO_FACE':
                    meeting.meetingModeClass = 'fas fa-user-friends';
                    break;
                default:
                    meeting.meetingModeClass = 'd-none';
                    break;
            }
            meeting.scheduledTime = moment(startDateTime).format("MMM DD, YYYY ( hh:mm a") + ' to ' + moment(endDateTime).format("hh:mm a )");
            meeting.userList = [];
            meeting.userNamesLabel = '';
            angular.forEach(meetingDetails.participants, (meetingUser, k) => {
                let user = {};
                user.userId = meetingUser.id;
                user.userName = meetingUser.firstName;
                if (!_.isUndefined(meetingUser.lastName) && !_.isNull(meetingUser.lastName)) {
                    user.userName += ' ' + meetingUser.lastName;
                }
                user.isPoc = meetingUser.isPoc;
                user.companyId = meetingUser.company.id;
                meeting.userList.push(user);
                if (this.candidateJobMatch.isSharedRequisition && !this.isCorporateFlag) {
                    if (user.isPoc) {
                        meeting.userNamesLabel = (meeting.userNamesLabel == '' ? user.userName : meeting.userNamesLabel + ', ' + user.userName);
                    }
                }
                else {
                    meeting.userNamesLabel = (meeting.userNamesLabel == '' ? user.userName : meeting.userNamesLabel + ', ' + user.userName);
                }
            });
            // meeting.label = user.userName + ' - ' + meeting.scheduledTime;
            this.meetingsList.push(meeting);
        });
    }
    getRecruiterQuestions(successCallback) {
        this.loadingFeedbackDetailsFlag = true;
        let meetingScheduleId = this.feedbackType == 'Screening' ? null : this.chosenMeeting.meetingScheduleId;
        let loggedInUserId = null;
        if (!this.loginRequired) {
            loggedInUserId = this.loggedInUserId;
        }
        this.feedbackExecutionService.getRecruiterQuestions(this.jobMatchId, this.userGetRecruiterQns, this.companyId, meetingScheduleId, loggedInUserId, (data) => {
            this.loadingFeedbackDetailsFlag = false;
            this.recruiterqns = angular.copy(data);
            this.recruiterqns.readOnly = true;
            if (this.context !== 'conference') {
                this.feedbackReadOnly = this.recruiterqns.readOnly;
            }
            this.candidateId = data.candidate.id;
            this.feedbackQuestionsCompanyId = null;
            angular.forEach(this.recruiterqns.companyQuestionsResults, (val, key) => {
                this.feedbackQuestionsCompanyId = key;
            });
            angular.forEach(this.recruiterqns.jobDetails, (job, key) => {
                if (!_.isNull(job.assignedRecruiterName)) {
                    let index = job.recruiterNames.findIndex((name) => {
                        return name == job.assignedRecruiterName;
                    });
                    if (index !== -1) {
                        job.recruiterNames.splice(index, 1);
                    }
                }
                if (this.feedbackType == 'Screening' && !job.feedbackSavedBefore) {
                    job.interested = null;
                }
            });
            // create random ids for questions that do not have ids
            // company questions
            angular.forEach(this.recruiterqns.companyQuestionsResults[this.feedbackQuestionsCompanyId], (val, key) => {
                if (_.isNull(val.id)) {
                    val.id = Math.floor((Math.random() * 100) + 1).toString();
                    val.randomIdCreatedFlag = true;
                    val.showComment = true;
                }
            });
            // client questions
            angular.forEach(this.recruiterqns.clientQuestionsResults, (clientVal, clientKey) => {
                angular.forEach(clientVal, (val, key) => {
                    if (_.isNull(val.id)) {
                        val.id = Math.floor((Math.random() * 100) + 1).toString();
                        val.randomIdCreatedFlag = true;
                        val.showComment = true;
                    }
                });
            });
            if (this.recruiterqns.sortedClientList.length == 0) {
                this.clientOrBuExists = false;
            }
            this.displayQuestions = true;
            for (let key in this.recruiterqns.jobDetails) {
                let jobDetailval = this.recruiterqns.jobDetails[key];
                this.type = jobDetailval.feedbackType;
                break;
            }
            if (this.type != 'R') {
                this.showInterested = false;
            }
            this.savedRecruiterQns = angular.copy(this.recruiterqns);
            this.checkifCompanyCompleted();
            this.initializeSliders();
            // Ensure bulk-formalize receives the current items once recruiter questions are loaded
            try {
                this.formalizeItemsArray = this._getAllItemsArray();
            }
            catch (e) {
                this.formalizeItemsArray = [];
            }
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.loadingFeedbackDetailsFlag = false;
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    getCompanyClass() {
        if (this.companyQnsComplete)
            return "panel-collapse collapse";
        else
            return "panel-collapse collapse in";
    }
    getClientClass() {
        if (this.checkifClientCompleted(keyval))
            return "panel-collapse collapse";
        else
            return "panel-collapse collapse in";
    }
    getJobClass() {
        if (this.checkifJobCompleted(keyval))
            return "panel-collapse collapse";
        else
            return "panel-collapse collapse in";
    }
    getOverallClass() {
        if (this.checkifCompanyOverallCompleted())
            return "panel-collapse collapse";
        else
            return "panel-collapse collapse in";
    }
    setClientJobCompleted() {
        for (let clientId in this.recruiterqns.clientListJobMatchDetails) {
            let jobArray = this.recruiterqns.clientListJobMatchDetails[clientId];
            for (let i = 0; i < jobArray.length; i++) {
                let jobId = jobArray[i];
                // commenting the 'checkifJobCompleted' and including just checkIfClientCompleted for now as job questions are not involved.
                // checkifClientCompleted(clientId) && checkifJobCompleted(jobId)
                if (this.checkifClientCompleted(clientId)) {
                    this.recruiterqns.jobDetails[jobId].completed = true;
                }
                else {
                    this.recruiterqns.jobDetails[jobId].completed = false;
                }
            }
        }
    }
    setNonClientJobsAsCompletedIfCompleted() {
        angular.forEach(this.recruiterqns.jobDetails, (val, key) => {
            if (_.isNull(val.clientName) && val.interested) {
                // if client Name is null, it means the job does not belong to any client - which can happen in case of corporation as BU is not mandatory.
                // if the job has been marked as interested, it means it can be marked as completed as there are no further questions to answer.
                val.completed = true;
            }
        });
    }
    checkifCompanyCompleted() {
        this.isCompanyQuestionExists = false;
        if (this.recruiterqns === undefined || this.recruiterqns == '') {
            this.companyQnsComplete = false;
            return false;
        }
        let companykey;
        for (let key in this.recruiterqns.companyQuestionsResults) {
            companykey = key;
        }
        let companyQuestion = this.recruiterqns.companyQuestionsResults[companykey];
        if (companyQuestion != null) {
            for (let i = 0; i < companyQuestion.length; i++) {
                let recruiterComment = companyQuestion[i].recruiterComment;
                let overallQuestion = companyQuestion[i].question;
                let sliderId = companyQuestion[i].rating;
                if (overallQuestion != 'Overall Comment') {
                    this.isCompanyQuestionExists = true;
                    if (this.isEmpty(recruiterComment) && sliderId == "0") {
                        this.companyQnsComplete = false;
                        return false;
                    }
                }
            }
        }
        return true;
    }
    checkifAllClientCompleted() {
        for (let key in this.recruiterqns.clientQuestionsResults) {
            let clientQuestion = this.recruiterqns.clientQuestionsResults[key];
            if (this.clientNotInterestedList.indexOf(key) > -1) {
                continue;
            }
            if (clientQuestion != null) {
                for (let i = 0; i < clientQuestion.length; i++) {
                    let recruiterComment = clientQuestion[i].recruiterComment;
                    let sliderId = clientQuestion[i].rating;
                    if (this.isEmpty(recruiterComment) && sliderId == "0") {
                        return false;
                    }
                }
            }
        }
        return true;
    }
    checkifClientCompleted(key) {
        let clientQuestion = this.recruiterqns.clientQuestionsResults[key];
        if (clientQuestion && clientQuestion.length > 0) {
            for (let i = 0; i < clientQuestion.length; i++) {
                let recruiterComment = clientQuestion[i].recruiterComment;
                let sliderId = clientQuestion[i].rating;
                if (this.isEmpty(recruiterComment) && sliderId == "0") {
                    return false;
                }
            }
            return true;
        }
        else {
            return true;
        }
    }
    checkifJobCompleted(key) {
        let jobQuestion = this.recruiterqns.jobQuestionsResults[key];
        for (let i = 0; i < jobQuestion.length; i++) {
            let recruiterComment = jobQuestion[i].recruiterComment;
            let sliderId = jobQuestion[i].rating;
            if (this.isEmpty(recruiterComment) && sliderId == "0") {
                return false;
            }
        }
        return true;
    }
    checkifAllJobCompleted() {
        for (let key in this.recruiterqns.jobQuestionsResults) {
            let jobQuestion = this.recruiterqns.jobQuestionsResults[key];
            if (this.jobNotInterestedList.indexOf(key) > -1) {
                continue;
            }
            for (let i = 0; i < jobQuestion.length; i++) {
                let recruiterComment = jobQuestion[i].recruiterComment;
                let sliderId = jobQuestion[i].rating;
                if (this.isEmpty(recruiterComment) && sliderId == "0") {
                    return false;
                }
            }
        }
        return true;
    }
    checkifCompanyOverallCompleted() {
        if (this.recruiterqns === undefined || this.recruiterqns == '')
            return true;
        let companykey;
        if (this.recruiterqns != null && this.recruiterqns.companyQuestionsResults != null) {
            for (let key in this.recruiterqns.companyQuestionsResults) {
                companykey = key;
            }
            let companyQuestion = this.recruiterqns.companyQuestionsResults[companykey];
            if (companyQuestion != null) {
                for (let i = 0; i < companyQuestion.length; i++) {
                    let recruiterComment = companyQuestion[i].recruiterComment;
                    let overallQuestion = companyQuestion[i].question;
                    let sliderId = companyQuestion[i].rating;
                    if (overallQuestion == 'Overall Comment') {
                        if (this.isEmpty(recruiterComment) && sliderId == "0") {
                            return false;
                        }
                    }
                }
            }
        }
        return true;
    }
    countJobQns() {
        return this.totalCount++;
    }
    countClientQns() {
        return this.totalClQnsCount++;
    }
    isEmpty(str) {
        return (!str || 0 === str.trim().length);
    }
    initializeSliders() {
        this.$timeout(() => {
            this.initCoSliders();
            this.initClSliders();
            this.initJobSliders();
            $("div[class='overall-qn-slider']").each((i, obj) => {
                let questionId = obj.id.split('__')[1];
                let questionIndex = this.getQuestionIndex('Company', this.feedbackQuestionsCompanyId, 'id', questionId);
                let labelId = "overall-qn-rating__" + questionId;
                $(obj).noUiSlider({
                    range: [0, 10], start: [0], step: 1, handles: 1, connect: 'lower',
                    slide: () => {
                        let val = $(obj).val();
                        $("#" + labelId).text(Math.round(val));
                        this.recruiterqns.companyQuestionsResults[this.feedbackQuestionsCompanyId][questionIndex].rating = parseInt(val);
                    },
                    set: () => {
                        let val = $(obj).val();
                        $("#" + labelId).text(Math.round(val));
                        this.recruiterqns.companyQuestionsResults[this.feedbackQuestionsCompanyId][questionIndex].rating = parseInt(val);
                    }
                });
                // set the initial value
                $(obj).val(this.recruiterqns.companyQuestionsResults[this.feedbackQuestionsCompanyId][questionIndex].rating, true);
            });
        }, 200);
    }
    getQuestionIndex(questionType, questionTypeId, propName, propValue) {
        let questionIndex = 0;
        let questionsArray = [];
        if (questionType == 'Company') {
            questionsArray = this.recruiterqns.companyQuestionsResults[questionTypeId];
        }
        else if (questionType == 'Client') {
            questionsArray = this.recruiterqns.clientQuestionsResults[questionTypeId];
        }
        if (propName == 'id') {
            questionIndex = _.findIndex(questionsArray, { 'id': propValue });
        }
        else if (propName == 'question') {
            questionIndex = _.findIndex(questionsArray, { 'question': propValue });
        }
        return questionIndex;
    }
    initCoSliders() {
        $("div[class='co-qn-slider']").each((i, obj) => {
            let questionId = obj.id.split('__')[1];
            let questionIndex = this.getQuestionIndex('Company', this.feedbackQuestionsCompanyId, 'id', questionId);
            let labelId = "co-qn-rating__" + questionId;
            $(obj).noUiSlider({
                range: [0, 10], start: [0], step: 1, handles: 1, connect: 'lower',
                slide: () => {
                    let val = $(obj).val();
                    $("#" + labelId).text(Math.round(val));
                    this.recruiterqns.companyQuestionsResults[this.feedbackQuestionsCompanyId][questionIndex].rating = parseInt(val);
                },
                set: () => {
                    let val = $(obj).val();
                    $("#" + labelId).text(Math.round(val));
                    this.recruiterqns.companyQuestionsResults[this.feedbackQuestionsCompanyId][questionIndex].rating = parseInt(val);
                }
            });
            // set the initial value
            $(obj).val(this.recruiterqns.companyQuestionsResults[this.feedbackQuestionsCompanyId][questionIndex].rating, true);
        });
    }
    initClSliders() {
        $("div[class='cl-qn-slider']").each((i, obj) => {
            let clientId = obj.id.split('__')[1];
            let questionId = obj.id.split('__')[2];
            let questionIndex = this.getQuestionIndex('Client', clientId, 'id', questionId);
            let labelId = "cl-qn-rating__" + clientId + '__' + questionId;
            $(obj).noUiSlider({
                range: [0, 10], start: [0], step: 1, handles: 1, connect: 'lower',
                slide: () => {
                    let val = $(obj).val();
                    $("#" + labelId).text(Math.round(val));
                    this.recruiterqns.clientQuestionsResults[clientId][questionIndex].rating = parseInt(val);
                },
                set: () => {
                    let val = $(obj).val();
                    $("#" + labelId).text(Math.round(val));
                    this.recruiterqns.clientQuestionsResults[clientId][questionIndex].rating = parseInt(val);
                }
            });
            // set the initial value
            $(obj).val(this.recruiterqns.clientQuestionsResults[clientId][questionIndex].rating, true);
        });
    }
    initJobSliders() {
        $("div[id='job-qn-slider']").each((i, obj) => {
            let labelId = "#job-qn-rating" + ++i;
            $(obj).noUiSlider({
                range: [0, 10], start: [0], step: 1, handles: 1, connect: 'lower',
                slide: () => {
                    let val = $(obj).val();
                    $(labelId).text(Math.round(val));
                },
                set: () => {
                    let val = $(obj).val();
                    $(labelId).text(Math.round(val));
                }
            });
            let qnRating = $(labelId).text();
            $(obj).val(qnRating, true);
        });
    }
    filterFunction(element) {
        return element.question.match(/^Overall/) ? false : true;
    }
    filterFunctionForOverall(element) {
        if (element != null) {
            return element.question.match(/^Overall/) ? true : false;
        }
    }
    clearObjects() {
        this.recruiterqns = "";
    }
    filterByInterested() {
        if (this.clientOrBuExists && this.feedbackType != 'Outreach') {
            for (let clientId in this.recruiterqns.clientListJobMatchDetails) {
                let showClient = false;
                let jobArray = this.recruiterqns.clientListJobMatchDetails[clientId];
                for (let i = 0; i < jobArray.length; i++) {
                    let jobId = jobArray[i];
                    // commenting as job questions are not involved right now
                    // let x = document.getElementById(jobId);
                    if (this.recruiterqns.jobDetails[jobId].interested) {
                        // commenting as job questions are not involved right now
                        // x.style.display = "block";
                        showClient = true;
                    }
                    else {
                        // commenting as job questions are not involved right now
                        // x.style.display = "none";
                    }
                    let y = document.getElementById(clientId);
                    if (showClient) {
                        y.style.display = "block";
                    }
                    else {
                        y.style.display = "none";
                    }
                }
            }
        }
    }
    toDisplayJobPanel(jobMatchId) {
        let jobQuestionList = this.recruiterqns.jobQuestionsResults[jobMatchId];
        if (jobQuestionList == null || jobQuestionList.length == 0) {
            return false;
        }
        else {
            return true;
        }
    }
    toDisplayClientPanel(clientKey) {
        let clientQuestionList = this.recruiterqns.clientQuestionsResults[clientKey];
        if (clientQuestionList == null) {
            return false;
        }
        else {
            return true;
        }
    }
    isClientJobEnabled(clientId) {
        let jobArray = this.recruiterqns.clientListJobMatchDetails[clientId];
        let isClientJobEnabledFlag = false;
        angular.forEach(jobArray, (jobId, key) => {
            if (this.recruiterqns.jobDetails[jobId].interested) {
                isClientJobEnabledFlag = true;
            }
        });
        return isClientJobEnabledFlag;
    }
    closeModal() {
        if (!_.isUndefined(this.completeFeedbackCallback)) {
            this.completeFeedbackCallback();
        }
    }
    _checkIfContactDetailsMissing() {
        let candidateJobMatch = _.cloneDeep(this.candidateJobMatch);
        candidateJobMatch.candidateAdditionalDetails.workLocations = this.candidateJobMatch.workLocations;
        this.isCandidateContactDetailsMissing = !this.sharedService.isContactDetailsAvailable(candidateJobMatch, 'candidateJobMatchCard');
        this.isCandidateContactAdditionalDetailsMissing = !this.sharedService.isCandidateAdditionalDetailsAvailable(candidateJobMatch);
        if (this.isCandidateContactAdditionalDetailsMissing) {
            if (this.candidateContactDetailsMissingCallback) {
                this.candidateContactDetailsMissingCallback({ result: true });
            }
        }
        else {
            if (this.candidateContactDetailsMissingCallback) {
                this.candidateContactDetailsMissingCallback({ result: false });
            }
        }
    }
    _setCandidateMissingDetailsMessage(contactDetails, additionalDetails) {
        let message = [];
        if (contactDetails) {
            if (!this.candidateJobMatch.email)
                message.push('Email');
            if (!this.candidateJobMatch.mobilephone)
                message.push('Phone Number');
            if ((!this.candidateJobMatch.address || (!this.candidateJobMatch.address.zipcode || this.candidateJobMatch.address.zipcode == "")))
                message.push('Zip code');
        }
        if (additionalDetails) {
            if (!this.candidateJobMatch.candidateAdditionalDetails) {
                message.push('Preferred JobType', 'Salary', 'Work Authorization', 'Work Location');
            }
            else {
                if (!this.candidateJobMatch.candidateAdditionalDetails.preferredJobTypeDetails || this.candidateJobMatch.candidateAdditionalDetails.preferredJobTypeDetails.jobType.length === 0)
                    message.push('Preferred JobType', 'Salary');
                if (!this.candidateJobMatch.candidateAdditionalDetails.sponsorships || this.candidateJobMatch.candidateAdditionalDetails.sponsorships.length === 0)
                    message.push('Work Authorization');
                if (!this.candidateJobMatch.workLocations || this.candidateJobMatch.workLocations.length === 0)
                    message.push('Work Locations');
            }
        }
        return message.toString().replaceAll(",", ", ");
    }
    _checkCandidateMissingInfo(successCallback, cancelCallback) {
        let contactMissingInfoMessage = this._setCandidateMissingDetailsMessage(this.isCandidateContactDetailsMissing, this.isCandidateContactAdditionalDetailsMissing);
        let title = "Missing Information";
        let message = `<div>
                            <p>The useful information of the candidate <span>'<span class="emerald">${contactMissingInfoMessage}</span>'</span> is missing and needs to be entered.<p>
                            <p>Complete anyway?</p>
                        </div>`;
        this.alertsAndNotificationsService.showConfirm(title, message, 'warning', true, () => {
            if (successCallback) {
                successCallback();
            }
            this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        }, () => {
            if (cancelCallback) {
                cancelCallback();
            }
            this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        });
    }
    completeModal(fromButton) {
        this.saveResults(fromButton);
        /* setTimeout(() =>  {
           if(!_.isUndefined(this.completeFeedbackCallback)){
                 this.completeFeedbackCallback();
             }
         }, 5000);*/
    }
    cancelModal() {
        let showConfirmationPopup = false;
        if (!angular.equals(this.savedRecruiterQns, this.recruiterqns) || !angular.equals(this.savedCandidateAdditionalDetails, this.candidateAdditionalDetails)) {
            showConfirmationPopup = true;
        }
        if (showConfirmationPopup) {
            bootbox.hideAll();
            bootbox.confirm({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Warning!</strong></div>",
                message: "Unsaved data on the page will be lost.<br><br> Do you still want to continue?",
                className: "zIndex1060",
                buttons: {
                    confirm: {
                        label: 'Yes',
                        className: 'btn-success'
                    },
                    cancel: {
                        label: 'Cancel',
                        className: 'btn-danger'
                    }
                },
                callback: (result) => {
                    if (result) {
                        if (!_.isUndefined(this.closeModal)) {
                            this.closeModal();
                        }
                    }
                    this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                }
            });
        }
        else {
            if (!_.isUndefined(this.closeModal)) {
                this.closeModal();
            }
        }
    }
    addQuestion(category, categoryId) {
        let sliderIdPrefix = '';
        let sliderTextIdPrefix = '';
        let ratingId = '';
        let newQuestion = {};
        if (category == 'Company') {
            newQuestion = this._createDuplicateQuestion(this.recruiterqns.companyQuestionsResults[categoryId][0], categoryId, 'company');
            this.recruiterqns.companyQuestionsResults[categoryId].push(newQuestion);
            sliderIdPrefix = 'co-qn-slider';
            sliderTextIdPrefix = 'co-qn-rating';
        }
        else if (category == 'Client') {
            newQuestion = this._createDuplicateQuestion(this.recruiterqns.clientQuestionsResults[categoryId][0], categoryId, 'clientOrBu');
            this.recruiterqns.clientQuestionsResults[categoryId].push(newQuestion);
            sliderIdPrefix = 'cl-qn-slider__' + categoryId;
            sliderTextIdPrefix = 'cl-qn-rating__' + categoryId;
        }
        this.$timeout(() => {
            let questionIndex = this.getQuestionIndex(category, categoryId, 'id', newQuestion.id);
            $('#' + sliderIdPrefix + '__' + newQuestion.id).noUiSlider({
                range: [0, 10], start: [0], step: 1, handles: 1, connect: 'lower',
                slide: () => {
                    let val = $('#' + sliderIdPrefix + '__' + newQuestion.id).val();
                    $("#" + sliderTextIdPrefix + "__" + newQuestion.id).text(Math.round(val));
                    if (category == 'Company') {
                        this.recruiterqns.companyQuestionsResults[categoryId][questionIndex].rating = parseInt(val);
                    }
                    else {
                        this.recruiterqns.clientQuestionsResults[categoryId][questionIndex].rating = parseInt(val);
                    }
                },
                set: () => {
                    let val = $('#' + sliderIdPrefix + '__' + newQuestion.id).val();
                    $("#" + sliderTextIdPrefix + "__" + newQuestion.id).text(Math.round(val));
                    if (category == 'Company') {
                        this.recruiterqns.companyQuestionsResults[categoryId][questionIndex].rating = parseInt(val);
                    }
                    else {
                        this.recruiterqns.clientQuestionsResults[categoryId][questionIndex].rating = parseInt(val);
                    }
                }
            });
            $('#' + sliderIdPrefix + '__' + newQuestion.id).val(0, true);
        }, 200);
    }
    removeQuestion(category, categoryId, questionId) {
        let questionsArray = [];
        if (category == 'Company') {
            questionsArray = this.recruiterqns.companyQuestionsResults[categoryId];
        }
        else if (category == 'Client') {
            questionsArray = this.recruiterqns.clientQuestionsResults[categoryId];
        }
        let questionIndex = this.getQuestionIndex(category, categoryId, 'id', questionId);
        questionsArray.splice(questionIndex, 1);
    }
    _createDuplicateQuestion(question, companyClientOrBuId, companyType) {
        let questionDuplicate = {};
        if (!_.isUndefined(question)) {
            questionDuplicate = angular.copy(question);
        }
        // set the variables to defaults
        questionDuplicate.question = "";
        questionDuplicate.rating = 0;
        questionDuplicate.recruiterComment = null;
        questionDuplicate.questionareDateTime = null;
        questionDuplicate.userId = null;
        // create a temporary Id
        questionDuplicate.id = Math.floor((Math.random() * 100) + 1).toString();
        questionDuplicate.recruiterName = null;
        questionDuplicate.questionType = null;
        questionDuplicate.lastModifiedBy = null;
        questionDuplicate.participantId = null;
        questionDuplicate.jobmatchId = null;
        questionDuplicate.newQuestionFlag = true;
        questionDuplicate.candidateId = this.candidateId;
        if (companyType == 'clientOrBu') {
            questionDuplicate.clientorbuId = companyClientOrBuId;
            questionDuplicate.companyId = this.companyId;
            questionDuplicate.externalComment = null;
            questionDuplicate.questionOrder = 0;
        }
        return questionDuplicate;
    }
    saveResults(fromButton, successCallback) {
        if (fromButton == "save" && this.feedbackType == 'Screening') {
            let feedbackSaveNeeded = !angular.equals(this.savedRecruiterQns, this.recruiterqns);
            let candidateAdditionalDetailsSaveNeeded = !angular.equals(this.savedCandidateAdditionalDetails, this.candidateAdditionalDetails);
            let hasUnselectedJobs = this._hasUnSelectedJobs();
            if (hasUnselectedJobs) {
                this._showUnSelectedJobsModal();
            }
            else if (!feedbackSaveNeeded && !candidateAdditionalDetailsSaveNeeded) {
                // show no data to save modal only when it is in save mode
                this._showNoDataToSaveModal();
            }
            else if (feedbackSaveNeeded && candidateAdditionalDetailsSaveNeeded) {
                this._saveFeedback(fromButton, () => {
                    this._saveCandidateAdditionalDetails(false);
                });
            }
            else if (feedbackSaveNeeded) {
                this._saveFeedback(fromButton);
            }
            else if (candidateAdditionalDetailsSaveNeeded) {
                this._saveCandidateAdditionalDetails(true);
            }
        }
        else if (fromButton == "save" && this.feedbackType !== 'Screening') {
            if (!this._hasFeedbackChanged()) {
                // show no data to save modal only when it is in save mode
                this._showNoDataToSaveModal();
            }
            else {
                this._saveFeedback(fromButton);
            }
        }
        else if (fromButton === 'complete' && this.feedbackType == 'Screening') {
            if (this._hasUnSelectedJobs()) {
                this._showUnSelectedJobsModal();
            }
            else {
                this._checkIfContactDetailsMissing();
                if (this.completeButtonLabel != 'Update' && (this.isCandidateContactDetailsMissing || this.isCandidateContactAdditionalDetailsMissing)) {
                    this._checkCandidateMissingInfo(() => {
                        this._saveFeedback(fromButton, () => {
                            if (!angular.equals(this.savedCandidateAdditionalDetails, this.candidateAdditionalDetails)) {
                                this._saveCandidateAdditionalDetails(false);
                            }
                        });
                    }, () => {
                        if (this._hasFeedbackChanged()) {
                            this._saveFeedback('save');
                        }
                    });
                }
                else {
                    this._saveFeedback(fromButton, () => {
                        if (!angular.equals(this.savedCandidateAdditionalDetails, this.candidateAdditionalDetails)) {
                            this._saveCandidateAdditionalDetails(false);
                        }
                    });
                }
            }
        }
        else {
            this._checkIfContactDetailsMissing();
            if (this.completeButtonLabel != 'Update' && fromButton === 'complete' && (this.isCandidateContactDetailsMissing || this.isCandidateContactAdditionalDetailsMissing)) {
                this._checkCandidateMissingInfo(() => {
                    this._saveFeedback(fromButton, () => {
                        if (!angular.equals(this.savedCandidateAdditionalDetails, this.candidateAdditionalDetails)) {
                            this._saveCandidateAdditionalDetails(false);
                        }
                    });
                }, () => {
                    if (this._hasFeedbackChanged()) {
                        this._saveFeedback('save');
                    }
                });
            }
            else {
                this._saveFeedback(fromButton);
            }
        }
    }
    _hasUnSelectedJobs() {
        for (const jobId in this.recruiterqns.jobDetails) {
            if (this.feedbackType == 'Screening' && this.recruiterqns.jobDetails[jobId].interested == null) {
                return true;
            }
        }
        return false;
    }
    _hasFeedbackChanged() {
        return !angular.equals(this.savedRecruiterQns, this.recruiterqns);
    }
    _saveFeedback(fromButton, successCallback) {
        let statusOfSave;
        let listofCompanyQuestions;
        let listofClientQuestions = [];
        let listofJobQuestions = [];
        let overallCommentsQuestionIndex;
        let companyCompleted = true;
        let clientAllCompleted = true;
        let newQuestionErrorExistFlag = false;
        let joballCompleted = true;
        let participantId = '';
        let companyOverallCompleted = true;
        // populate the participant Id
        if (this.userList.length == 1) {
            participantId = this.userList[0].id;
        }
        else {
            participantId = this.userGetRecruiterQns;
        }
        if (this.recruiterqns != null) {
            angular.forEach(this.recruiterqns.companyQuestionsResults[this.feedbackQuestionsCompanyId], (val, key) => {
                val.questionareDateTime = this.dateTimeUtilityService.getCurrentTimeStampInAPIFormat();
                val.questionType = this.type;
                val.lastModifiedBy = _.isNull(this.userId) ? this.loggedInUserId : this.userId;
                val.participantId = participantId;
                if (val.question != 'Overall Comment') {
                    if (val.rating == "0" && this.isEmpty(val.recruiterComment)) {
                        companyCompleted = false;
                    }
                    if (!_.isUndefined(val.newQuestionFlag) && val.question.trim() == "") {
                        newQuestionErrorExistFlag = true;
                    }
                }
                else if (val.question == 'Overall Comment') {
                    if (val.rating == "0" && this.isEmpty(val.recruiterComment)) {
                        companyOverallCompleted = false;
                    }
                }
            });
            listofCompanyQuestions = this.recruiterqns.companyQuestionsResults[this.feedbackQuestionsCompanyId];
            angular.forEach(this.recruiterqns.clientQuestionsResults, (clientVal, clientKey) => {
                if (this.isClientJobEnabled(clientKey)) {
                    angular.forEach(clientVal, (val, key) => {
                        val.questionareDateTime = this.dateTimeUtilityService.getCurrentTimeStampInAPIFormat();
                        val.questionType = this.type;
                        val.lastModifiedBy = _.isNull(this.userId) ? this.loggedInUserId : this.userId;
                        val.participantId = participantId;
                        if (val.rating == "0" && this.isEmpty(val.recruiterComment)) {
                            clientAllCompleted = false;
                        }
                        if (!_.isUndefined(val.newQuestionFlag) && val.question.trim() == "") {
                            newQuestionErrorExistFlag = true;
                        }
                    });
                    if (listofClientQuestions) {
                        listofClientQuestions = listofClientQuestions.concat(clientVal);
                    }
                    else {
                        listofClientQuestions = clientVal;
                    }
                }
            });
            for (let key in this.recruiterqns.jobQuestionsResults) {
                if (this.toDisplayJobPanel(key)) {
                    let spanId = "job-qn" + key;
                    $("span[id=" + spanId + "]").each((i, obj) => {
                        let jobQnNoFldId = "job-qn-no" + key;
                        let jobQnNo = $("input[id=" + jobQnNoFldId + "]")[i].value;
                        let sliderId = "#job-qn-rating" + jobQnNo;
                        let textAreaId = "#job-qn-comments" + jobQnNo;
                        this.recruiterqns.jobQuestionsResults[key][i]["rating"] = $(sliderId).text();
                        this.recruiterqns.jobQuestionsResults[key][i]["recruiterComment"] = $(textAreaId).val();
                        this.recruiterqns.jobQuestionsResults[key][i]["questionareDateTime"] = this.dateTimeUtilityService.getCurrentTimeStampInAPIFormat();
                        this.recruiterqns.jobQuestionsResults[key][i]["questionType"] = this.type;
                        this.recruiterqns.jobQuestionsResults[key][i]["lastModifiedBy"] = _.isNull(this.userId) ? this.loggedInUserId : this.userId;
                        this.recruiterqns.jobQuestionsResults[key][i]["participantId"] = participantId;
                        if (this.recruiterqns.jobQuestionsResults[key][i]["rating"] == "0" && this.isEmpty(this.recruiterqns.jobQuestionsResults[key][i]["recruiterComment"])) {
                            joballCompleted = false;
                        }
                    });
                    if (listofJobQuestions) {
                        listofJobQuestions = listofJobQuestions.concat(this.recruiterqns.jobQuestionsResults[key]);
                    }
                    else {
                        listofJobQuestions = this.recruiterqns.jobQuestionsResults[key];
                    }
                    let jobQuestionList = this.recruiterqns.jobQuestionsResults[key];
                    if (jobQuestionList == null || jobQuestionList.length == 0) {
                        joballCompleted = true;
                    }
                }
            }
            let listOfCompanyquest = listofCompanyQuestions ? listofCompanyQuestions.concat(listofClientQuestions) : [];
            // commenting for now as job questions are not involved now.
            //listOfQuestionsResults = listOfCompanyquest.concat(listofJobQuestions);
            let listOfQuestionsResults = listOfCompanyquest;
            this.setClientJobCompleted();
            this.setNonClientJobsAsCompletedIfCompleted();
            //  this.feedbackExecutionResult = new FeedbackExecutionResult();
            if (companyCompleted && clientAllCompleted && companyOverallCompleted) {
                this.feedbackExecutionResult.companyAndOverallComplete = "complete";
            }
            else {
                this.feedbackExecutionResult.companyAndOverallComplete = "notcomplete";
            }
            let listOfjobdetails = [];
            for (let key in this.recruiterqns.jobDetails) {
                listOfjobdetails.push(this.recruiterqns.jobDetails[key]);
            }
            this.feedbackExecutionResult.companyId = this.companyId;
            this.feedbackExecutionResult.feedbackAnswersList = listOfQuestionsResults;
            this.feedbackExecutionResult.jobDetailsRecruiterScreeningList = listOfjobdetails;
            this.feedbackExecutionResult.fromButton = fromButton;
            this.feedbackExecutionResult.meetingScheduleId = this.feedbackType == 'Screening' ? null : this.chosenMeeting.meetingScheduleId;
            this.feedbackExecutionResult.externalMeetingId = this.feedbackType == 'Screening' && !this.externalMeetingCallId ? null : this.externalMeetingCallId;
            // validation before save
            if (newQuestionErrorExistFlag) {
                // new questions added but no question value is given
                bootbox.alert({
                    closeButton: false,
                    title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Question not provided!</strong></div>",
                    message: "Question cannot be empty. <br>Please provide a question and its rating for all the new questions added.",
                    className: "zIndex1060",
                    buttons: {
                        ok: {
                            label: 'Ok',
                            className: 'btn-info'
                        }
                    },
                    callback: () => {
                        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                    }
                });
            }
            else if (fromButton === 'complete' && (!companyCompleted || !clientAllCompleted || !companyOverallCompleted)) {
                // complete / update is clicked and all the questions are not answered
                let message = "Please answer all the questions to complete the feedback form.";
                if (this.completeButtonLabel == 'Update') {
                    message = "Please answer all the questions to update the feedback form.";
                }
                bootbox.alert({
                    closeButton: false,
                    title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Incomplete Form!</strong></div>",
                    message: message,
                    className: "zIndex1060",
                    buttons: {
                        ok: {
                            label: 'Ok',
                            className: 'btn-info'
                        }
                    },
                    callback: () => {
                        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                    }
                });
            }
            else if (((this.feedbackType == 'Screening' && this.candidateJobMatch.jobMatchCurrentState == 'Activated') || ((this.feedbackType == 'Interview' || this.feedbackType == 'PhoneScreen') && this.chosenMeeting.status == 'COMPLETED')) && (!companyCompleted || !clientAllCompleted || !companyOverallCompleted)) {
                // save is clicked for recruiter screening for a job match that is in activated state (meaning completion).
                // or
                // save is clicked for an interview or phone screen that is already completed
                // and
                // all questions are not answered.
                bootbox.alert({
                    closeButton: false,
                    title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Incomplete Form!</strong></div>",
                    message: "You are saving a Completed Feedback form. Please answer all the questions.",
                    className: "zIndex1060",
                    buttons: {
                        ok: {
                            label: 'Ok',
                            className: 'btn-info'
                        }
                    },
                    callback: () => {
                        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                    }
                });
            }
            else {
                if (fromButton == 'save') {
                    $("#cancelBtn").prop("disabled", true);
                    $("#completeBtn").prop("disabled", true);
                    this.savingFlag = true;
                }
                else if (fromButton == 'complete') {
                    $("#cancelBtn").prop("disabled", true);
                    $("#saveBtn").prop("disabled", true);
                    this.completingFlag = true;
                }
                // remove newQuestionFlag or randomIdCreatedFlag and temporary id on new questions
                angular.forEach(this.feedbackExecutionResult.feedbackAnswersList, (val, key) => {
                    if (!_.isUndefined(val.newQuestionFlag)) {
                        // set the id to null
                        val.id = null;
                        // delete the new question flag.
                        delete val.newQuestionFlag;
                    }
                    else if (!_.isUndefined(val.randomIdCreatedFlag)) {
                        // set the id to null
                        val.id = null;
                        // delete the random id created flag.
                        delete val.randomIdCreatedFlag;
                    }
                });
                let loggedInUserId = null;
                if (!this.loginRequired) {
                    loggedInUserId = this.loggedInUserId;
                }
                this.feedbackExecutionService.saveRecruiterQuestions(angular.toJson(this.feedbackExecutionResult), this.jobMatchId, loggedInUserId, (data) => {
                    if (successCallback) {
                        successCallback();
                    }
                    if (fromButton == 'save') {
                        this.savingFlag = false;
                        $("#cancelBtn").prop("disabled", false);
                        $("#completeBtn").prop("disabled", false);
                        if (!_.isUndefined(this.saveCallback)) {
                            // call the save call back on save, if it is defined
                            this.saveCallback();
                        }
                        // refresh the data on screen.
                        this.init(true);
                    }
                    else if (fromButton == 'complete') {
                        let feedbackTypeLabel = 'Screening';
                        let completeTypeLabel = 'completed';
                        this.completingFlag = false;
                        if (this.feedbackType == 'Screening') {
                            if (this.candidateJobMatch.jobMatchCurrentState == 'Activated') {
                                completeTypeLabel = 'updated';
                            }
                        }
                        else if (this.feedbackType == 'Interview' || this.feedbackType == 'PhoneScreen') {
                            feedbackTypeLabel = this.feedbackType == 'Interview' ? 'Interview' : 'Phone Screen';
                            if (this.chosenMeeting.status == 'COMPLETED') {
                                completeTypeLabel = 'updated';
                            }
                        }
                        let successMessage = 'The ' + feedbackTypeLabel + ' Feedback has been ' + completeTypeLabel + ' successfully.';
                        bootbox.alert({
                            closeButton: false,
                            title: "<div class='alert alert-success' style='margin-bottom: 0px;'><i class='fa fa-check fa-fw fa-lg'></i><strong>Success!</strong></div>",
                            message: successMessage,
                            className: "zIndex1060",
                            buttons: {
                                ok: {
                                    label: 'Ok',
                                    className: 'btn-info'
                                }
                            },
                            callback: () => {
                                if (!_.isUndefined(this.completeFeedbackCallback)) {
                                    setTimeout(() => {
                                        this.completeFeedbackCallback();
                                        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                                    }, 300);
                                }
                                else {
                                    this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                                    // refresh the data on screen.
                                    this.init(true);
                                }
                            }
                        });
                    }
                }, (error) => {
                    this.savingFlag = false;
                    this.completingFlag = false;
                    $("#cancelBtn").prop("disabled", false);
                    this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                });
            }
        }
    }
    _saveCandidateAdditionalDetails(isSuccessMessageNeeded) {
        this.candidateService.addOrUpdateCandidateAdditionalDetails(this.candidateAdditionalDetails, (data) => {
            if (isSuccessMessageNeeded) {
                this.alertsAndNotificationsService.showBannerMessage(data.message, 'success');
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    _showUnSelectedJobsModal() {
        let message = "Some job matches have not been marked as Interested or Not Interested.";
        let isAllJobMatchesUnselected = true;
        for (const jobId in this.recruiterqns.jobDetails) {
            if (this.recruiterqns.jobDetails[jobId].interested !== null) {
                isAllJobMatchesUnselected = false;
                break;
            }
        }
        if (isAllJobMatchesUnselected) {
            message = "None of the job matches have been marked as Interested or Not Interested";
        }
        bootbox.alert({
            closeButton: false,
            title: "<div class='alert alert-warning mb-0'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Alert!</strong></div>",
            message: message,
            className: "zIndex1060",
            buttons: {
                ok: {
                    label: 'Ok',
                    className: 'btn-info'
                }
            },
            callback: () => {
                this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            }
        });
    }
    _showNoDataToSaveModal() {
        bootbox.alert({
            closeButton: false,
            title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Alert!</strong></div>",
            message: "Nothing to Save!",
            className: "zIndex1060",
            buttons: {
                ok: {
                    label: 'Ok',
                    className: 'btn-info'
                }
            },
            callback: () => {
                this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            }
        });
    }
    markAllJobsAsInterested() {
        for (let jobId in this.recruiterqns.jobDetails) {
            this.recruiterqns.jobDetails[jobId].interested = true;
        }
        this.filterByInterested();
    }
    onInternalNoteChanged() {
        let indexOfOverallQuestion = this._getIndexOfOverallQuestion();
        this.recruiterqns.companyQuestionsResults[this.feedbackQuestionsCompanyId][indexOfOverallQuestion].externalComment = this.recruiterqns.companyQuestionsResults[this.feedbackQuestionsCompanyId][indexOfOverallQuestion].recruiterComment;
    }
    onExternalNoteChange(event) {
        let indexOfOverallQuestion = this._getIndexOfOverallQuestion();
        this.recruiterqns.companyQuestionsResults[this.feedbackQuestionsCompanyId][indexOfOverallQuestion].externalComment = event.externalNote;
    }
    _getIndexOfOverallQuestion() {
        return this.recruiterqns.companyQuestionsResults[this.feedbackQuestionsCompanyId].findIndex(question => question.question == "Overall Comment");
    }
    onCopyNoteChange(event) {
        this.copyNote = event.copyNote;
    }
    openConference(meeting) {
        window.open(meeting.meetingUrl, "_blank");
    }
    toggleCompanyQuestionComments() {
        this.showAllCompanyQuestionComments = !this.showAllCompanyQuestionComments;
        angular.forEach(this.recruiterqns.companyQuestionsResults[this.feedbackQuestionsCompanyId], (val, key) => {
            val.showComment = this.showAllCompanyQuestionComments;
        });
    }
    toggleClientQuestionComments(clientId) {
        this.showAllClientQuestionComments = !this.showAllClientQuestionComments;
        angular.forEach(this.recruiterqns.clientQuestionsResults[clientId], (val, key) => {
            val.showComment = this.showAllClientQuestionComments;
        });
    }
    viewJobProfile(jobId) {
        // $(".modal").addClass("job-match-meetings-modal-large");
        $(".modal").addClass("job-match-meetings-modal-large");
        this.$timeout(() => {
            this.$uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                windowTopClass: 'four-dot-five-modal-large',
                backdrop: 'static',
                keyboard: false,
                component: 'feedbackExecutionActionsModal',
                resolve: {
                    actionType: () => {
                        return 'jobProfile';
                    },
                    jobId: () => {
                        return jobId;
                    }
                }
            }).result.then(callback => {
                //do nothing
            }, dismiss => {
                this.$timeout(() => {
                    $(".modal").removeClass("job-match-meetings-modal-large");
                }, 600);
            });
        }, 300);
    }
    viewCandidateBooklet(meeting) {
        let meetingId = meeting ? meeting.id : this.parentScheduleId;
        let usersList = meeting ? meeting.userList : this.feedbackUserIdsList;
        $(".modal").addClass("job-match-meetings-modal-medium");
        this.$timeout(() => {
            this.$uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                windowTopClass: 'four-dot-five-modal-large',
                backdrop: 'static',
                keyboard: false,
                component: 'feedbackExecutionActionsModal',
                resolve: {
                    actionType: () => {
                        return 'candidateBooklet';
                    },
                    candidateId: () => {
                        return this.candidateJobMatch.id;
                    },
                    jobId: () => {
                        return this.candidateJobMatch.jobMatchJobId;
                    },
                    jobMatchId: () => {
                        return this.jobMatchId;
                    },
                    feedbackType: () => {
                        return this.feedbackType;
                    },
                    feedbackUserIdsList: () => {
                        return usersList;
                    },
                    scheduleId: () => {
                        return meetingId;
                    }
                }
            }).result.then(callback => {
                if (callback.callbackType == 'refresh') {
                    this.completeFeedbackCallback();
                }
                this.$timeout(() => {
                    $(".modal").removeClass("job-match-meetings-modal-medium");
                }, 600);
            }, dismiss => {
                this.$timeout(() => {
                    $(".modal").removeClass("job-match-meetings-modal-large");
                }, 600);
            });
        }, 300);
    }
    onUserWhoCanEditFeedbackChange() {
        this.enabledEditForUser = this.usersToEditFeedback.find(user => user.attendeeId == this.enableEditForAttendeeId);
        if (angular.equals(this.savedRecruiterQns, this.recruiterqns)) {
            this._confirmEnablingUserToEdit();
        }
        else {
            this._alertUserToSaveTheFeedback();
        }
    }
    _confirmEnablingUserToEdit() {
        let message = `Only '${this.enabledEditForUser.displayName}' will be allowed to edit the feedback.<br><br> Do you want to continue?`;
        bootbox.hideAll();
        bootbox.confirm({
            closeButton: false,
            title: "<div class='alert alert-warning mb-0'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Confirm</strong></div>",
            message: message,
            className: "zIndex1060",
            backdrop: true,
            onEscape: false,
            buttons: {
                confirm: {
                    label: 'Yes',
                    className: 'btn-info'
                },
                cancel: {
                    label: 'Cancel',
                    className: 'btn-danger'
                }
            },
            callback: (result) => {
                if (result) {
                    this._approveUserToEditFeedback(true);
                }
                else {
                    this._selectPreviousUser();
                }
            }
        });
    }
    _selectPreviousUser() {
        this.loadingUsers = true;
        this.enabledEditForUser = angular.copy(this.previousEnableEditFor);
        if (this.previousEnableEditFor !== null) {
            this.enableEditForAttendeeId = this.previousEnableEditFor.attendeeId;
        }
        else {
            this.enableEditForAttendeeId = this.previouslyEnabledEditForAttendeeId;
            this.enabledEditForUser = this.usersToEditFeedback.find(user => user.attendeeId == this.enableEditForAttendeeId);
        }
        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        this.$timeout(() => {
            this.loadingUsers = false;
        }, 1000);
    }
    _alertUserToSaveTheFeedback() {
        this.enabledEditForUser = angular.copy(this.previousEnableEditFor);
        if (this.previousEnableEditFor == null) {
            this.enableEditForAttendeeId = null;
        }
        bootbox.alert({
            closeButton: false,
            title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Feedback is not saved!</strong></div>",
            message: "Please save your feedback.",
            className: "zIndex1060",
            buttons: {
                ok: {
                    label: 'Ok',
                    className: 'btn-info'
                }
            },
            callback: () => {
                this._selectPreviousUser();
            }
        });
    }
    _approveUserToEditFeedback(isApproved, requesterAttendeeId) {
        let currentUserAttendeeId = this.usersToEditFeedback.find(user => user.displayName == 'You').attendeeId;
        let enableEditForAttendeeId = isApproved ? this.enableEditForAttendeeId : requesterAttendeeId;
        let attendeeIds = this.usersToEditFeedback.map(attendee => attendee.attendeeId);
        let approvalDetails = {
            attendeeId: enableEditForAttendeeId,
            approverId: currentUserAttendeeId,
            meetingScheduleId: this.parentScheduleId,
            externalMeetingCallId: this.externalMeetingCallId,
            attendeeIds: attendeeIds,
            approved: isApproved
        };
        this.meetingService.giveFeedbackEditApproval(approvalDetails, (data) => {
            if (isApproved) {
                this.previousEnableEditFor = angular.copy(this.enabledEditForUser);
            }
        }, error => {
            this.alertsAndNotificationsService.showToastMessage(error.message, 'danger');
        });
    }
    requestPermissionToEdit() {
        // this.disableRequestToEditButton = true;
        let currentUserAttendeeId = this.usersToEditFeedback.find(user => user.displayName === "You").attendeeId;
        let requestDetails = {
            attendeeId: this.enableEditForAttendeeId,
            externalMeetingCallId: this.externalMeetingCallId,
            requesterAttendeeId: currentUserAttendeeId
        };
        this.meetingService.getFeedbackEditRequestApproval(requestDetails, (data) => {
            if (data) {
                bootbox.alert({
                    closeButton: false,
                    title: "<div class='alert alert-success mb-0'><i class='fa fa-check fa-fw fa-lg'></i><strong>Request sent!</strong></div>",
                    message: `Request to edit feedback sent.`,
                    className: "zIndex1060",
                    buttons: {
                        ok: {
                            label: 'Ok',
                            className: 'btn-info'
                        }
                    },
                    callback: () => {
                        //do nothing
                    }
                });
            }
            else {
                // this.disableRequestToEditButton = false;
                bootbox.alert({
                    closeButton: false,
                    title: "<div class='alert alert-warning mb-0'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Request not sent</strong></div>",
                    message: "Request to edit feedback not sent. Please try after some time.",
                    className: "zIndex1060",
                    buttons: {
                        ok: {
                            label: 'Ok',
                            className: 'btn-info'
                        }
                    },
                    callback: () => {
                        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                    }
                });
            }
        }, error => {
            // this.disableRequestToEditButton = false;
            bootbox.alert({
                closeButton: false,
                title: "<div class='alert alert-warning mb-0'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Request not sent</strong></div>",
                message: "Request to edit feedback not sent. Please try after some time.",
                className: "zIndex1060",
                buttons: {
                    ok: {
                        label: 'Ok',
                        className: 'btn-info'
                    }
                },
                callback: () => {
                    this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                }
            });
        });
    }
    openEditFeedbackApprovalModal(message) {
        this.$uibModalStack.dismissAll();
        let editFeedbackApprovalInfo = {
            requesterName: message.requesterName,
            isFeedbackChanged: this._hasFeedbackChanged()
        };
        this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            windowTopClass: 'four-dot-five-modal-small',
            backdrop: 'static',
            keyboard: false,
            component: 'feedbackExecutionActionsModal',
            resolve: {
                actionType: () => {
                    return 'feedbackEditApproval';
                },
                editFeedbackApprovalInfo: () => {
                    return editFeedbackApprovalInfo;
                }
            }
        }).result.then(callback => {
            if (callback.callbackType == 'saveAndApproveFeedbackEdit') {
                this.enableEditForAttendeeId = message.requesterAttendeeId;
                if (this._hasFeedbackChanged()) {
                    this._saveFeedback('save', () => {
                        this._approveUserToEditFeedback(true);
                    });
                }
                else {
                    this._approveUserToEditFeedback(true);
                }
            }
            else if (callback.callbackType == 'approveFeedbackEdit') {
                if (editFeedbackApprovalInfo.isFeedbackChanged) {
                    bootbox.hideAll();
                    bootbox.confirm({
                        closeButton: false,
                        title: "<div class='alert alert-warning mb-0'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Warning!</strong></div>",
                        message: "The changes you made to the feedback will not be saved.<br><br> Do you still want to continue?",
                        buttons: {
                            confirm: {
                                label: 'Yes',
                                className: 'btn-success'
                            },
                            cancel: {
                                label: 'No',
                                className: 'btn-danger'
                            }
                        },
                        callback: (result) => {
                            if (result) {
                                this.enableEditForAttendeeId = message.requesterAttendeeId;
                                this._approveUserToEditFeedback(true);
                            }
                        }
                    });
                }
                else {
                    this.enableEditForAttendeeId = message.requesterAttendeeId;
                    this._approveUserToEditFeedback(true);
                }
            }
            else if (callback.callbackType == 'denyFeedbackEdit') {
                this._approveUserToEditFeedback(false, message.requesterAttendeeId);
            }
        }, dismiss => {
            //do nothing
        });
    }
    _checkAndSaveFeedbackIfMeetingEnd() {
        this.$rootScope.$on("SAVE_FEEDBACK_ON_MEETING_END", (event, resolveCallback) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this._hasFeedbackChanged()) {
                yield this._saveFeedback('save', () => {
                    console.log('Feedback Saved');
                    if (resolveCallback)
                        resolveCallback();
                });
            }
            else {
                if (resolveCallback)
                    resolveCallback();
            }
        }));
    }
    getOutreachFeedbackQuestions() {
        this.loadingFeedbackDetailsFlag = true;
        if (this.outreachData) {
            this.setOutreachFeedbackData(this.outreachData);
        }
        else {
            this.outreachService.getOutreachFeedbackQuestions(this.candidateId, this.companyId, (data) => {
                this.setOutreachFeedbackData(data);
            }, (error) => {
                this.alertsAndNotificationsService.showToastMessage(error.message, 'danger');
            });
        }
    }
    setOutreachQuestionsForFeedback(clientIds) {
        if (this.recruiterqns && this.recruiterqns.clientDetails) {
            Object.keys(this.recruiterqns.clientDetails).forEach(clientId => {
                let el = document.getElementById(clientId);
                if (el) {
                    if (clientIds.includes(clientId)) {
                        el.style.display = "block";
                    }
                    else {
                        el.style.display = "none";
                    }
                }
            });
        }
    }
    setOutreachFeedbackData(data) {
        this.loadingFeedbackDetailsFlag = false;
        this.recruiterqns = angular.copy(data);
        this.recruiterqns.readOnly = true;
        // this.candidateId = data.candidate.id;
        // this.candidateId = this.candidateId;
        this.feedbackQuestionsCompanyId = null;
        angular.forEach(this.recruiterqns.companyQuestionsResults, (val, key) => {
            this.feedbackQuestionsCompanyId = key;
        });
        // company questions
        angular.forEach(this.recruiterqns.companyQuestionsResults[this.feedbackQuestionsCompanyId], (val, key) => {
            if (_.isNull(val.id)) {
                val.id = Math.floor((Math.random() * 100) + 1).toString();
                val.isIdValid = false;
                val.randomIdCreatedFlag = true;
                val.showComment = true;
            }
            else {
                val.isIdValid = true;
            }
        });
        // client questions
        angular.forEach(this.recruiterqns.clientQuestionsResults, (clientVal, clientKey) => {
            angular.forEach(clientVal, (val, key) => {
                if (_.isNull(val.id)) {
                    val.id = Math.floor((Math.random() * 100) + 1).toString();
                    val.isIdValid = false;
                    val.randomIdCreatedFlag = true;
                    val.showComment = true;
                }
                else {
                    val.isIdValid = true;
                }
            });
        });
        if (this.recruiterqns.sortedClientList.length == 0) {
            this.clientOrBuExists = false;
        }
        this.displayQuestions = true;
        for (let key in this.recruiterqns.jobDetails) {
            let jobDetailval = this.recruiterqns.jobDetails[key];
            this.type = jobDetailval.feedbackType;
            break;
        }
        if (this.type != 'R') {
            this.showInterested = false;
        }
        this.savedRecruiterQns = angular.copy(this.recruiterqns);
        this.checkifCompanyCompleted();
        this.initializeSliders();
        this.showMeetingLink = false;
        this.loadingFeedbackOptionsFlag = false;
        this.userHasAccessToFeedback = true;
        this.loadingFeedbackDetailsFlag = false;
        this.loadingJobMatchDetailsFlag = false;
        this.$timeout(() => {
            this.setOutreachQuestionsForFeedback(this.activeOutreachFeedbackQuestionsList);
        }, 300);
    }
    saveOutreachFeedback(successCallback) {
        let statusOfSave;
        let listofCompanyQuestions;
        let listofClientQuestions = [];
        let listofJobQuestions = [];
        let overallCommentsQuestionIndex;
        let companyCompleted = true;
        let clientAllCompleted = true;
        let companyOverallCompleted = true;
        if (this.recruiterqns != null) {
            let companyId = this.recruiterqns.candidateOutreachJobMatchInfo ? this.recruiterqns.candidateOutreachJobMatchInfo.jobMatches[0].companyId : this.companyId;
            angular.forEach(this.recruiterqns.companyQuestionsResults[companyId], (val, key) => {
                val.questionareDateTime = this.dateTimeUtilityService.getCurrentTimeStampInAPIFormat();
                val.questionType = 'O';
                val.lastModifiedBy = this.candidateId;
                val.participantId = this.candidateId;
                val.userId = this.candidateId;
                if (val.question != 'Overall Comment') {
                    if (val.rating == "0" && this.isEmpty(val.recruiterComment)) {
                        companyCompleted = false;
                    }
                }
                else if (val.question == 'Overall Comment') {
                    if (val.rating == "0" && this.isEmpty(val.recruiterComment)) {
                        companyOverallCompleted = false;
                    }
                }
            });
            if (!this.disableFeedbackQuestions) {
                listofCompanyQuestions = this.recruiterqns.companyQuestionsResults[companyId];
            }
            else {
                // When questions are disabled, only include the Overall Comment; skip regular company questions
                listofCompanyQuestions = this.recruiterqns.companyQuestionsResults[companyId].filter(val => val.question && val.question.match(/^Overall/));
            }
            angular.forEach(this.recruiterqns.clientQuestionsResults, (clientVal, clientKey) => {
                if (this.activeOutreachFeedbackQuestionsList.includes(clientKey)) {
                    angular.forEach(clientVal, (val, key) => {
                        val.questionareDateTime = this.dateTimeUtilityService.getCurrentTimeStampInAPIFormat();
                        val.questionType = 'O';
                        val.lastModifiedBy = this.candidateId;
                        val.participantId = this.candidateId;
                        val.userId = this.candidateId;
                        if (val.rating == "0" && this.isEmpty(val.recruiterComment)) {
                            clientAllCompleted = false;
                        }
                    });
                    if (listofClientQuestions) {
                        listofClientQuestions = listofClientQuestions.concat(clientVal);
                    }
                    else {
                        listofClientQuestions = clientVal;
                    }
                }
            });
        }
        if (this.activeOutreachFeedbackQuestionsList.length > 0 && (!companyCompleted || !clientAllCompleted || !companyOverallCompleted)) {
            if (successCallback) {
                successCallback({ isValid: false, listOfClientQuestions: listofClientQuestions, listOfCompanyQuestions: listofCompanyQuestions });
            }
        }
        else {
            if (successCallback) {
                successCallback({ isValid: true, listOfClientQuestions: listofClientQuestions, listOfCompanyQuestions: listofCompanyQuestions });
            }
        }
    }
    getAllPreferredJobTypes() {
        this.jobService.getAllJobTypes((data) => {
            this.jobTypeList = data;
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    getSalaryDurationOptions() {
        this.jobService.getSalaryDurationOptions((data) => {
            this.salaryDurationOptions = data;
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    $onDestroy() {
        if (this.externalMeetingCallId) {
            if (this.cleanUpMeetingEventOne) {
                this.cleanUpMeetingEventOne();
            }
            if (this.cleanUpMeetingEventTwo) {
                this.cleanUpMeetingEventTwo();
            }
            if (this.cleanUpMeetingEventThree) {
                this.cleanUpMeetingEventThree();
            }
        }
    }
}
FeedbackExecutionController.$inject = ['$rootScope', '$scope', '$timeout', '$uibModal', '$uibModalStack', 'companyService', 'feedbackExecutionService', 'userRoleService', 'jobMatchService', 'candidateService', 'meetingService', 'modalService', 'dateTimeUtilityService', 'alertsAndNotificationsService', 'sharedService', 'MESSAGECONSTANTS', 'outreachService', 'jobService', 'authService'];
// import * as TEMPLATE from './feedback-execution.html;
import * as TEMPLATE from 'raw-loader!./feedback-execution.html';
export const FeedbackExecutionComponent = {
    selector: 'feedbackExecutionScreen',
    component: {
        bindings: {
            jobMatchId: '@',
            candidateId: '@',
            saveCallback: '&',
            completeFeedbackCallback: '&',
            feedbackUserIdsList: '@',
            loginRequired: '<',
            externalCommentRequired: '<',
            feedbackType: '@',
            parentScheduleId: '@',
            childScheduleId: '@',
            context: '@',
            usersToEditFeedback: '<',
            feedbackReadOnly: '<',
            externalMeetingCallId: '=',
            candidateContactDetailsMissingCallback: '&',
            activeOutreachFeedbackQuestionsList: '@',
            outreachData: '@',
            disableFeedbackQuestions: '<',
            isFeedbackTabActive: '<',
            sourceScreen: '@',
            formalizeActivityPayload: '='
        },
        controller: FeedbackExecutionController,
        // templateUrl: 'app/shared/jobMatchActions/feedbackExecution/feedback-execution.html'
        template: TEMPLATE.default
    }
};
//# sourceMappingURL=feedback-execution.component.js.map